module.exports = __webpack_public_path__ + "static/img/Sleep-Data.049d0c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Sleep-Data.png
// module id = ndwS
// module chunks = 1